<template>
  <div class="room-warp">
    <!-- 顶部老师信息栏 -->
  	<y-teacher-info></y-teacher-info>
    <!-- 导航栏 -->
  	<y-nav></y-nav>
    <!-- 直播室 -->
    <div class="main yf-text_12 clearfix" v-if="roomData.lastTopicId > 0">
      <!-- 右侧 -->
      <div class="main_right right">
        <div class="content_top clearfix">
          <p class="left">同学互动</p>
          <p class="right">字体
            <span :class="{ active: fontSize === '18' }" @click="fontSize = '18'">大</span>
            <span :class="{ active: fontSize === '16' }" @click="fontSize = '16'">中</span>
            <span :class="{ active: fontSize === '14' }" @click="fontSize = '14'">小</span>
          </p>
        </div>
        <div ref="chat" class="content-right" :style="{ height: (isRoomManger || (!isRoomTeacher && !isRoomGuest) ? 726 : 724) + 'px' }">
          <div class="upButton" v-show="$store.state.room.commentList.length >= 50 && $store.state.room.commentList[0].index !== 0 && isChatLoading"><span @click="up('chat')">向上50条</span></div>
          <!-- components chat -->
          <y-chat
            :data="item"
            :key="item.id"
            @setRedpackData="setRedpackData"
            v-for="item of commentData"
            :font-size="fontSize"
            @imgLoad="toBottom('chat')"
            @showImg="showFullImg">
          </y-chat>
        </div>
        <!--同学互动区 over-->

        <!-- 礼物 -->
        <y-gift @present="present" v-if="isRoomManger || (!isRoomTeacher && !isRoomGuest)"></y-gift>
        <!-- 礼物 over -->

        <!-- 普通用户区域 -->
        <y-user-area :redpack-status.sync="redpack.status"></y-user-area>
        <!-- 普通用户区域 over -->
      </div>
      <!-- 右侧over -->

      <!-- 左侧 -->
      <div class="main_left left">
        <h1 class="title yf-text_16">
          {{ roomData.lastTopicTime }} 今日主题：{{ roomData.lastTopicName }}
          <span class="right yf-text_12">参与用户<i class="yf-text_red">{{ $store.state.room.online }}</i>人</span>
        </h1>
        <div class="live">
          <div v-if="t === 'main'" ref="live" :style="{ height: (isRoomManger || (!isRoomTeacher && !isRoomGuest) ? 726 : 550) + 'px' }">
        		<div class="upButton" v-show="$store.state.room.messageList.length >= 50 && $store.state.room.messageList[0].index !== 0 && isLiveLoading"><span @click="up('live')">向上50条</span></div>
        		<y-live
              :data="item"
              :key="item.id"
              v-for="item of messageData"
              @imgLoad="toBottom('live')"
              @showImg="showFullImg">
            </y-live>
        	</div>
          <div v-else-if="t === 'encrypted-view'" ref="live" class="view-live" :style="{ height: (isRoomManger || (!isRoomTeacher && !isRoomGuest) ? 726 : 550) + 'px' }">
            <y-encrypted-view :key="item.id" :data="item" v-for="item of encryptedViewData"></y-encrypted-view>
          </div>
        </div>
        <!-- 底部导航 -->
        <y-room-bottom-nav></y-room-bottom-nav>
        <!-- 底部导航 over -->

        <!-- 投票 & 推荐 -->
        <y-vote v-if="isRoomManger || (!isRoomTeacher && !isRoomGuest)"></y-vote>
        <!-- 投票 & 推荐 over-->

        <!-- 老师区 -->
        <y-editor-wrap v-if="isRoomTeacher || isRoomGuest"></y-editor-wrap>
        <!-- 老师区 over -->
      </div>
      <!-- 左侧over -->
    </div>
    <!-- 底部推荐 -->
    <y-elite-introduce v-if="!isRoomTeacher && !isRoomGuest"></y-elite-introduce>
    <!-- 底部推荐 over -->

    <!-- 红包活动 -->
    <!-- <transition name="bounce"> -->
    <YRedpack
      :redpack-status.sync="redpack.status"
      :message-id="redpack.messageId"
      :data="redpack.data"
      :redpack-info.sync="redpack.redpackInfo"
    />

    <!--老师直播室下方友情提示-->
    <div v-if="isRoomTeacher || isRoomGuest" class="tip-box main yf-text_12">
      <div class="tip">
        <span>特别提示：</span>严禁播主在网站任何地方有任何明示、暗示的联系方式，如手机号、Q号（昵称）、群号、微信号、QQ截图（抹去QQ号和昵称的除外）、外网的博客、外站网址、微博等。严禁煽动用户诋毁网站决议，损害网站在用户心目中的形象。一富财经工作团队奉行积极沟通、全面尊重主播意愿的原则，播主可以采用与网站工作人员私下沟通的方式提出自己的合理建议。禁止采用讽刺、诋毁、谩骂等不文明行为进行恶性竞争。如贬损其他播主、鼓励学生到别的直播室捣乱等。
      </div>
    </div>
    <!--全局间隔时间未登录的弹出-->
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      class="open_popup">
      <nuxt-link target="_blank" rel="noopener" to="/register?from=一富财经">
        <span class="close_span" @click.stop.prevent="dialogVisible = !dialogVisible"></span>
        <img src="~assets/tanchuang.png" alt="一富财经-未登录提示" />
      </nuxt-link>
    </el-dialog>
    <!-- 礼物弹窗 -->
    <y-user-dialog
      :visible.sync="giftVisible"
      title="赠送礼物"
      @close="handleReset"
      width="520px">
      <div class="gift-dialog" v-if="gift">
        <p class="gift-img center">
          <img class="inline" :src="gift.imgUrl" :alt="gift.name">
          <br> {{ gift.desc }}
        </p>
        <ul class="gift-desc">
          <li class="item item1 center clearfix">
            <p class="inline clearfix">
              <span class="left">礼物：</span>
              <b class="desc left">{{ gift.name }}</b>
            </p>
            <p class="inline clearfix">
              <span class="left">价格：</span>
              <span class="value left"><b class="yf-text_red">{{ giftPrice }}</b> {{ giftPriceType }}</span>
            </p>
          </li>
          <li class="item item2 clearfix">
            <span class="label left">赠送给：</span>
            <div class="gift-guests left clearfix">
              <p class="left" @click="handleCheck(roomData.teacherId)" :class="{ checked: presentList.indexOf(roomData.teacherId) !== -1 }"><span class="name inline ellipsis left">{{ roomData.teacherName }}</span> <i class="iconfont icon-zq left"></i></p>
              <p class="left" @click="handleCheck(item.userId)" v-for="item of $store.state.room.guests" :key="item.id" :class="{ checked: presentList.indexOf(item.userId) !== -1 }"><span class="name inline ellipsis left">{{ item.userName }}</span> <i class="iconfont icon-zq left"></i></p>
            </div>
          </li>
        </ul>
        <div class="footer clearfix">
          <span class="left">共需花费 <span class="yf-text_red">{{ giftTotalPrice }}</span> {{ giftPriceType }}</span>
          <span class="right">您的剩余{{ giftPriceType }}数：{{ giftRemain }} <nuxt-link class="yf-text_red" to="/pay" target="_blank">充值>></nuxt-link></span>
        </div>
        <div class="footer-btn center">
          <p v-if="giftRemain < 0" class="tip yf-text_red"><i class="iconfont icon-th"></i> 您的{{ giftPriceType }}不足，请充值...</p>
          <button type="button" class="btn-search" :disabled="giftWarning" :class="{ yf_warning: giftWarning }" @click="presentGift">{{ isLoading ? '赠送中...' : '立即赠送' }}</button>
        </div>
      </div>
    </y-user-dialog>
    <!-- 图片弹出框 -->
    <el-dialog fullscreen :visible.sync="fullImg">
      <div class="center">
        <img class="js-ubb-img-out" @click="fullImg = false" style="max-width: 90%" :src="fullImgSrc" alt="全屏图片" />
      </div>
    </el-dialog>
    <div id="dify-chatbot-container"></div>
    <div id="app">
    <!-- 其他内容 -->
    <DifyChatbot />
  </div>
  </div>
</template>

<script>
import YChat from '@/components/room/Chat'
import YLive from '@/components/room/Live'
import YRedpack from '@/components/room/Redpack'
import YEditorWrap from '@/components/room/EditorWrap'
import YUserDialog from '@/components/user/UserDialog'
import YTeacherInfo from '@/components/TeacherInfo'
import YNav from '@/components/Nav'
import YEncryptedView from '@/components/room/EncryptedView'
import YRoomBottomNav from '@/components/room/RoomBottomNav'
import YUserArea from '@/components/room/UserArea'
import YGift from '@/components/room/Gift'
import YVote from '@/components/room/Vote'
import YEliteIntroduce from '@/components/room/EliteIntroduce'
import { mapState, mapGetters } from 'vuex'
import { message } from '@/utils/Filters'
import { playAudio } from '@/utils/Misc'
import socket from '@/utils/Socket'
import DifyChatbot from '@/components/room/DifyChatbot'

export default {
  name: 'room',
  scrollToTop: true,
  validate ({ params }) {
    return params.id > 0
  },
  async fetch ({ params, query, store, redirect, error }) {
    // 初始化直播室数据
    let room = await store.dispatch('room/initRoomData', params.id)
    if (!room) {
      error({statusCode: 404, message: "该直播室不存在或数据加载失败！"})
      return
    }
    // 历史直播
    if ((room.lastTopicStatus === 21 || room.lastTopicStatus === undefined) && room.lastTopicId > 0) {
      // 今日未开播，进入历史直播
      redirect(`/room/history/${room.lastTopicId}`)
      return false
    }
    if (room.teacherId > 0) {
      // 初始化老师数据
      await store.dispatch('teacher/getInfo', room.teacherId)
    }

    if (room.lastTopicId > 0) {
      // 获取消息数据
      await store.dispatch('room/initList', room.lastTopicId)
      // 初始化邀请嘉宾
      await store.dispatch('room/initGuests', { topicId: room.lastTopicId })
    }
  },
  head () {
    return {
      title: `${this.roomData.teacherName}_${this.roomData.lastTopicName}_一富财经直播室`,
      meta: [
        { hid: 'keywords', name: 'keywords', content: `${this.roomData.teacherName}_一富财经_股市直播_股票_股票入门` },
      ],
      script: [
        { src: 'https://static.bshare.cn/b/buttonLite.js#uuid=a1a5f63b-900b-4d12-af01-08615dd4a12e&style=-1', async: '' },
        { src: 'https://dify.yifucj.com/embed.min.js',id:'wvJnA5d3FU636jni' }
      ]
    }
  },
  data () {
    return {
      // 未登录提示弹出框
      dialogVisible: false,
      chat: {
        top: false,
        bottom: true,
      },
      live: {
        top: false,
        bottom: true,
      },
      _ws: null,
      // 直播室初始化弹窗的时间s
      popT: 300,
      // 人气统计s
      popularityT: 300,
      fontSize: null,
      giftVisible: false,    // 礼物弹窗
      gift: null,             // 礼物信息
      presentList: [],       // 赠送人物列表
      isLoading: false,
      fullImg: false,
      fullImgSrc: '',
      // 红包相关
      redpack: {
        status: 0,
        messageId: 0,
        data: {},
        redpackInfo: {}
      }
    }
  },
  mounted () {
    this.fontSize = this.$cookies.get('yf_room_chat_font') || '16'
    if (this.isWebsocket) {
      this._ws = socket.launch(this)
      this.$store.commit('user/setUserPosition', true)
    } else {
      this.polling()
    }
    this.loadData()
    this.$nextTick(() => {
      this.toBottom('live')
      this.toBottom('chat')
      if(!this.$isLogin()) {
        this.initPopup()
      }
    })

    window.addEventListener('focus', this['commit'])
    window.addEventListener('blur', this['commit'])
  },
  beforeDestroy () {
    this.$store.commit('room/setMessageList', [])
    window.removeEventListener('focus', this['commit'])
    window.removeEventListener('blur', this['commit'])
    if (this._ws) {
      this.$store.commit('user/setUserPosition', false)
      this._ws.close()
    }
    this.popularityTimer && clearInterval(this.popularityTimer)
    this.pollingTimer && clearInterval(this.pollingTimer)
    this.popTimer && clearInterval(this.popTimer)
  },
  methods: {
      setRedpackData (type, data) {
      if (type === null) {
        this.redpack.messageId = data
      } else if (type === 1) {
        this.redpack.data = data
      } else {
        this.redpack.redpackInfo = data
      }
    },
    // 播放消息提示音
    play () {
      playAudio(this.$cookies.get('yf_sound_' + this.$route.params.id))
    },
    commit () {
      this.$store.commit('room/setPageFocus')
    },
  	initPopup () {
  	  this.popTimer = setInterval(_ => this.dialogVisible = true, this.popT * 1000)
  	},
    async loadData () {
      // 获取付费观点数据
      await this.$store.dispatch('room/initEncryptedViewList', this.roomData.lastTopicId)

      if (this.$isLogin()) {
        if (this.isRoomTeacher) {
          // 获取问答相关数据
          await this.$store.dispatch('user/initAskNum')
        } else if (!this.isRoomGuest && !this.isRoomTeacher) {
          // 初始可售卖产品
          await this.$store.dispatch('teacher/getGoods', this.roomData.teacherId)
        }
        if (this.isRoomGuest || this.isRoomTeacher) {
          // 初始化常用观点
          await this.$store.dispatch('user/initNormalView')
        }
      }
      
      // 人气统计定时器
      this.popularityTimer = setInterval(() => {
        this.popularity()
      }, 1000 * this.popularityT)
      // 马上执行一次，由于guid是异步生成，所以这边加一个100毫秒的延时
      setTimeout(() => {
        this.popularity()
      }, 100)
    },
    // 人气统计
    popularity () {
      this.$axios._post('Popularity/Refresh', {
        topic_id: this.roomData.lastTopicId,
        source: 1
      }).then(res => {
        res && res.joins >= 0 && this.$store.commit('room/setOnline', res.joins)
      })
    },
    // 轮询
    polling (time = 3000) {
      this.pollingTimer = setInterval(_ => {
        this.$store.dispatch('room/polling', this.roomData.lastTopicId)
      }, time)
    },
    up (type) {
      this[type].top = true
      this.$store.dispatch('room/upList', {
        topicId: this.roomData.lastTopicId,
        type: type === 'chat' ? 'comment' : 'message',
        num: 50
      })
    },
    // 判断当前有效数据条数是否大于0
    filterList (list) {
      return list.map(_ => _.m !== 'DEL').length - list.map(_ => _.m === 'DEL').length > 0
    },
    // 滚动到顶部
    toTop (type) {
      this.$nextTick(() => {
        this[type].top = false
        setTimeout(() => {
          this.$refs[type].scrollTop = 0
        }, 200)
      })
    },
    // 滚动到底部
    toBottom (type) {
      const dom = this.$refs[type]
      if (!dom) {
        return
      }
      if (!this[type].bottom) {
        let offset = dom.scrollHeight - dom.scrollTop - dom.offsetHeight
        // 获取最后一个dom的高度
        let list = dom.querySelectorAll(`.${type}-item`)
        let lastDomHeight = list.length > 0 ? list[list.length - 1].offsetHeight : 0
        if (offset > lastDomHeight)
        return
      }
      this.$nextTick(() => {
        dom.scrollTop = dom.scrollHeight
      })
    },
    // 以下四个方法都是送礼相关
    present (item) {
      this.gift = item
      this.handleCheck(this.roomData.teacherId)
      this.giftVisible = true
    },
    handleCheck (id) {
      let i = this.presentList.indexOf(id)
      if (i === -1) {
        this.presentList.push(id)
      } else {
        this.presentList.splice(i, 1)
      }
    },
    handleReset () {
      this.gift = null
      this.presentList = []
    },
    presentGift () {
      const params = {
        topic_id: this.roomData.lastTopicId,
        gift_id: this.gift.id,
        teacher_ids: this.presentList.join(','),
        pay: this.giftTotalPrice,
        type: this.isRoomManger ? 1 : 0
      }
      this.isLoading = true
      this.$axios._post('Room/Gift', params).then(res => {
        this.giftVisible = false
        // 返回的数据没有index，要加上
        // 后端返回数组，暂时先这样处理
        if (!this.isWebsocket) {
          for (let i = 0; i < res.length; i++) {
            res[i].index = this.$store.state.room.mIndex
            this.$store.commit('room/addMessage', res[i])
          }
        }
        // 扣除G币或积分
        this.isRoomManger ? this.$store.commit(this.isRoomManger ? 'user/setGcents' : 'user/setGcoins', this.giftRemain) : this.$store.commit('user/setGcoins', this.giftRemain)
        this.$notify({
          title: '成功',
          message: '送礼成功',
          type: 'success'
        })
        this.handleReset()
        this.isLoading = false
      }).catch(e => {
        this.isLoading = false
      })
    },
    showFullImg (src) {
      this.fullImgSrc = src
      this.fullImg = true
    }
  },
  computed: {
    t () {
      return this.$route.query.t || 'main'
    },
    ...mapState('room', {
      newMessageNum: state => state.newMessageNum,
      isWebsocket: state => state.isWebsocket,
      roomData: state => state.data,
      messageData: state => message(state.messageList),
      // commentData: state => message(state.commentList, state.user.data),
      encryptedViewData: state => state.encryptedViewList,
      isChatLoading: state => state.isLoading['comment'],
      isLiveLoading: state => state.isLoading['message']
    }),
    commentData () {
      return message(this.$store.state.room.commentList, this.$store.state.user.data)
    },
    ...mapGetters({
      isRoomManger: 'user/isManger',
      isRoomTeacher: 'room/isTeacher',
      isRoomGuest: 'room/isGuest'
    }),
    // 以下五个计算属性和礼物相关
    giftPrice () {
      return this.isRoomManger ? this.gift.gcents : this.gift.gcoins
    },
    giftPriceType () {
      return this.isRoomManger ? '积分' : 'G币'
    },
    giftTotalPrice () {
      return this.presentList.length * this.giftPrice
    },
    giftRemain () {
      return this.isRoomManger ? this.$store.state.user.data.gcents - this.giftTotalPrice : this.$store.state.user.data.gcoins - this.giftTotalPrice
    },
    giftWarning () {
      return this.presentList.length < 1 || this.giftRemain < 0
    }
  },
  watch: {
    fontSize (n) {
      n === '16' ? this.$cookies.remove('yf_room_chat_font') : this.$cookies.set('yf_room_chat_font', n, 2000)
    },
		messageData (data, oldData) {
      this.live.bottom = oldData.length === 0
      this[`${this.live.top ? 'toTop' : 'toBottom'}`]('live')
      // 播放消息提示声音（只限用户）
      if(data[oldData.length].type === 1 || data[oldData.length].type === 2 || data[oldData.length].type === 6 || data[oldData.length].type === 7 || data[oldData.length].type === 10 || data[oldData.length].type === 12){
        if (oldData.length && (!this.isRoomManger && !this.isRoomTeacher && !this.isRoomGuest)) {
          this.play()
        }
      }
		},
    commentData (data, oldData) {
      this.isTeacher && this.play()
      this.chat.bottom = oldData.length === 0
      this[`${this.chat.top ? 'toTop' : 'toBottom'}`]('chat')
      // 播放消息提示声音（只限老师）
      if (oldData.length && (this.isRoomManger || this.isRoomTeacher || this.isRoomGuest)) {
        this.play()
      }
    },
    encryptedViewData (data, oldData) {
      // 付费观点没有向上50条，所以不用判断top
      this.live.bottom = oldData.length === 0
      this.toBottom('live')
    },
    newMessageNum (n) {
      document.title = `${(n ? '【新消息' + n + '条】' : '') + this.roomData.teacherName}：${this.roomData.lastTopicName}—一富财经直播室`
    },
    '$route.query.t': function () {
      this.toBottom('live')
    }
  },
  components: {
    YLive,
    YChat,
    YRedpack,
    YEditorWrap,
  	YTeacherInfo,
		YNav,
    YEncryptedView,
    YRoomBottomNav,
    YUserArea,
    YGift,
    YVote,
    YEliteIntroduce,
    YUserDialog,
    DifyChatbot
  }
}
</script>

<style lang="less" scoped>
 
.gift-dialog {
  color: #333333;
  .gift-img {
    margin-top: 15px; font-size: 12px;
    img {
      padding: 5px; border: 1px solid #eaeaea; border-radius: 4px;
    }
  }
  .gift-desc {
    margin-top: 15px; font-size: 16px;
    .item {
      margin-top: 10px;
      &.item1 p:first-child {
        margin-right: 20px;
      }
      &.item2 {
        margin-top: 20px;
      }
      .label {
        width: 80px; text-align: right;
      }
      .gift-guests {
        width: 400px;
        p {
          border: 1px solid #eaeaea; border-radius: 3px; padding: 3px 10px; margin: 0 5px 5px 0; cursor: pointer;
          span {
            margin-right: 5px;
            &.name { max-width: 100px; }
          }
          .icon-zq { margin-top: 4px; }
          &:hover {
            border-color: #e43a3d; color: #e43a3d;
          }
          &.checked {
            border-color: #e43a3d; background-color: #e43a3d; color: #ffffff;
          }
        }
      }
    }
  }
  .footer {
    margin-top: 10px; font-size: 14px;
  }
  .footer-btn {
    margin-top: 15px;
    .tip {
      margin-bottom: 10px; font-size: 14px;
      .icon-th {
        vertical-align: -5%;
      }
    }
  }
}
</style>
